import React from 'react';
import { Box, Typography, Grid } from "@mui/material";
import Style from './LinkiameSection.module.scss';
import { info } from "../../info/Info";
import linkiame3 from '../../img/linkiame/3.png';

export default function LinkiameSection() {
    return (
        <Box
            component={'section'}
            className={Style.linkiameSection}
            py={{xs: '3rem', md: '5rem'}}
            px={{xs: '1rem', md: '2rem'}}
        >
            <Box maxWidth={'1200px'} margin={'0 auto'}>
                <Box textAlign={'center'} mb={{xs: '2rem', md: '3rem'}}>
                    <Typography
                        variant={'h2'}
                        fontSize={{xs: '2rem', md: '3rem'}}
                        fontWeight={'bold'}
                        mb={'1rem'}
                    >
                        <span className={Style.star}>⭐</span> Featured Project: <span style={{background: info.gradient, webkitBackgroundClip: 'text', webkitTextFillColor: 'transparent'}}>Linkiame</span>
                    </Typography>
                    <Typography
                        variant={'h5'}
                        fontSize={{xs: '1rem', md: '1.25rem'}}
                        color={'text.secondary'}
                    >
                        A comprehensive SaaS platform for managing digital presence
                    </Typography>
                </Box>

                <Grid container spacing={4} alignItems={'center'} mb={{xs: '2rem', md: '3rem'}}>
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant={'body1'}
                            fontSize={{xs: '1rem', md: '1.1rem'}}
                            lineHeight={'1.8'}
                            textAlign={'justify'}
                            mb={'1.5rem'}
                        >
                            Linkiame is a SaaS platform built with Laravel and Livewire, designed to help entrepreneurs
                            manage their digital presence through customizable link pages, digital catalogs, and an online
                            booking system.
                        </Typography>
                        <Typography
                            variant={'body1'}
                            fontSize={{xs: '1rem', md: '1.1rem'}}
                            lineHeight={'1.8'}
                            textAlign={'justify'}
                        >
                            I contributed to the backend architecture, relational database design, and cloud deployment
                            using DigitalOcean. I also worked on performance optimization, automated deployment with
                            Laravel Forge, and external service integrations for notifications and usage analytics.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box className={Style.imageContainer}>
                            <img src={linkiame3} alt="Linkiame Platform" className={Style.screenshot} />
                        </Box>
                    </Grid>
                </Grid>

                <Box>
                    <Typography
                        variant={'h4'}
                        fontSize={{xs: '1.5rem', md: '2rem'}}
                        fontWeight={'bold'}
                        mb={'1.5rem'}
                    >
                        Key Contributions
                    </Typography>
                    <Grid container spacing={2}>
                        {[
                            {
                                title: "Backend Architecture",
                                description: "Designed and implemented scalable backend architecture with Laravel, ensuring code maintainability and performance."
                            },
                            {
                                title: "Database Design",
                                description: "Created efficient relational database schemas with MySQL, optimizing queries for high performance."
                            },
                            {
                                title: "Cloud Deployment",
                                description: "Managed cloud infrastructure on DigitalOcean with automated deployment pipelines using Laravel Forge."
                            },
                            {
                                title: "Performance Optimization",
                                description: "Implemented caching strategies, query optimization, and code refactoring to improve application performance."
                            },
                            {
                                title: "External Integrations",
                                description: "Integrated third-party services for notifications, analytics, and payment processing."
                            },
                            {
                                title: "DevOps Practices",
                                description: "Set up CI/CD pipelines, monitoring systems, and automated testing workflows."
                            }
                        ].map((contribution, index) => (
                            <Grid item xs={12} md={6} key={index}>
                                <Box className={Style.contributionCard} p={'1.5rem'}>
                                    <Typography
                                        variant={'h6'}
                                        fontSize={{xs: '1.1rem', md: '1.25rem'}}
                                        fontWeight={'bold'}
                                        mb={'0.5rem'}
                                        style={{color: info.baseColor}}
                                    >
                                        {contribution.title}
                                    </Typography>
                                    <Typography
                                        variant={'body2'}
                                        fontSize={{xs: '0.9rem', md: '1rem'}}
                                        lineHeight={'1.6'}
                                    >
                                        {contribution.description}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                <Box mt={{xs: '2rem', md: '3rem'}} textAlign={'center'}>
                    <Typography
                        variant={'h5'}
                        fontSize={{xs: '1.25rem', md: '1.5rem'}}
                        fontWeight={'bold'}
                        mb={'1rem'}
                    >
                        Tech Stack
                    </Typography>
                    <Box display={'flex'} flexWrap={'wrap'} gap={'1rem'} justifyContent={'center'}>
                        {['Laravel', 'Livewire', 'MySQL', 'TailwindCSS', 'DigitalOcean', 'Laravel Forge'].map((tech, index) => (
                            <Box
                                key={index}
                                className={Style.techBadge}
                                px={'1.5rem'}
                                py={'0.75rem'}
                            >
                                <Typography fontSize={{xs: '0.9rem', md: '1rem'}} fontWeight={'500'}>
                                    {tech}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>

                <Box mt={{xs: '2rem', md: '3rem'}} textAlign={'center'}>
                    <a
                        href="https://linkiame.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className={Style.visitButton}
                    >
                        Visit Linkiame.com
                    </a>
                </Box>
            </Box>
        </Box>
    );
}
